export default class FormCriteria {
    static getDate() {
        if (location.search) {
            const data = window.queryString.parse(location.search);

            if (data.date !== undefined && typeof data.date === 'string' && data.date !== '') {
                try {
                    const timestamp = window.moment(data.date, 'MM-DD-YYYY');
                    const maxDate = window.moment().startOf('day').add(process.env.VUE_APP_MAX_DAYS, 'day');

                    if (timestamp.isBefore(window.moment().startOf('day'))) {
                        return '';
                    } else if (timestamp.isAfter(maxDate)) {
                        return maxDate;
                    } else {
                        return timestamp;
                    }
                } catch (error) {
                    // Fall through.
                }
            }
        }

        return '';
    }

    static getSort() {
        if (location.search) {
            const data = window.queryString.parse(location.search);

            if (
                data.sort !== undefined &&
                typeof data.sort === 'string' &&
                window._.includes(['soonest', 'closest'], data.sort)
            ) {
                return data.sort;
            }
        }

        return 'soonest';
    }
}
